import { render, staticRenderFns } from "./InsectPestAdd.vue?vue&type=template&id=ebfa4ace&scoped=true&"
import script from "./InsectPestAdd.vue?vue&type=script&lang=ts&"
export * from "./InsectPestAdd.vue?vue&type=script&lang=ts&"
import style0 from "./InsectPestAdd.vue?vue&type=style&index=0&id=ebfa4ace&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfa4ace",
  null
  
)

export default component.exports